import React, { Component } from 'react'
import {
  Button,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col
} from 'reactstrap'
import styled from 'styled-components'
import StarRatings from 'react-star-ratings'
import { withNamespaces } from 'react-i18next'

import Preloader from '../UI/Preloader'

import StyledTextarea from '../Forms/Textarea'
import StyledButton from '../Forms/Button'

const StyledModalContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px 30px 35px 30px;

  font-family: 'Open Sans', sans-serif;
  font-weight: 500;
`

const StyledTitle = styled.div`
  margin-bottom: 30px;
  /* margin: 30px auto; */
  font-size: 13px;
  text-align: center;
  color: #19233c;
  text-transform: uppercase;
`

const ModalFooterWrapper = styled(ModalFooter)`
  padding-bottom: 0 !important;
  border: none !important;
`

const StyledRatingContainer = styled.div`
  font-family: 'Open Sans', sans-serif;

  & > div {
    margin-bottom: 10px;
  }
`

class Feedback extends Component {
  constructor(props) {
    super(props)

    const { initialRate } = props

    this.state = {
      modal: false,
      time: initialRate,
      qualification: initialRate,
      communication: initialRate,
      comment: ''
    }
  }

  closeTicketHandler = () => {
    const { closeTicket, sendFeedback, isTicketClosed } = this.props
    const { comment, time, qualification, communication } = this.state

    const feedbackData = {
      comment,
      mark: time,
      mark2: qualification,
      mark3: communication
    }

    if (isTicketClosed) {
      sendFeedback(feedbackData)
      this.closeModal()
    } else {
      closeTicket(feedbackData)
      this.closeModal()
    }
  }

  commentInputHandler = (ev) => {
    const { value } = ev.target

    this.setState({
      comment: value
    })
  }

  closeModal = () => {
    const { toggle, allowToClose } = this.props

    if (!allowToClose) {
      return null
    }

    this.setState(
      {
        time: 0,
        qualification: 0,
        communication: 0,
        comment: ''
      },
      () => {
        toggle()
      }
    )
  }

  changeRating = (newRating, name) => {
    this.setState({
      [name]: newRating
    })
  }

  render() {
    const { isOpen, t, allowToClose, loading } = this.props
    const { time, qualification, communication, comment } = this.state

    return (
      <React.Fragment>
        <Modal
          isOpen={isOpen}
          toggle={this.closeModal}
          contentClassName="styled_modal_content"
        >
          {loading && <Preloader />}
          <StyledModalContent>
            <StyledTitle>{t('tickets:opinionTitle')}</StyledTitle>
            <StyledRatingContainer>
              <div>{t('tickets:opinionBody')}</div>
              <div className="d-flex justify-content-between align-items-center">
                <div>{t('tickets:time')}:</div>
                <div>
                  {' '}
                  <StarRatings
                    starDimension={'30px'}
                    rating={time}
                    starRatedColor="#4c84ff"
                    changeRating={this.changeRating}
                    numberOfStars={5}
                    name="time"
                  />
                </div>
              </div>
              <div className="d-flex justify-content-between align-items-center">
                <div>{t('tickets:qualification')}:</div>
                <div>
                  {' '}
                  <StarRatings
                    starDimension={'30px'}
                    rating={qualification}
                    starRatedColor="#4c84ff"
                    changeRating={this.changeRating}
                    numberOfStars={5}
                    name="qualification"
                  />
                </div>
              </div>
              <div className="d-flex justify-content-between align-items-center">
                <div>{t('tickets:communication')}:</div>
                <div>
                  {' '}
                  <StarRatings
                    starDimension={'30px'}
                    rating={communication}
                    starRatedColor="#4c84ff"
                    changeRating={this.changeRating}
                    numberOfStars={5}
                    name="communication"
                  />
                </div>
              </div>

              <Row>
                <Col sm={12}>
                  <StyledTextarea
                    type="textarea"
                    input={{
                      value: comment,
                      name: 'comment',
                      id: 'comment',
                      onChange: this.commentInputHandler,
                      disabled: !(time && qualification && communication)
                    }}
                    label={t('tickets:comment')}
                  />
                </Col>
              </Row>
            </StyledRatingContainer>
            <ModalFooterWrapper>
              {allowToClose && (
                <StyledButton onClick={this.closeModal} outline bgColor="#fff">
                  {t('common:cancel')}
                </StyledButton>
              )}
              {this.renderSendButton()}
            </ModalFooterWrapper>
          </StyledModalContent>
        </Modal>
      </React.Fragment>
    )
  }

  renderSendButton = () => {
    const { t, isTicketClosed } = this.props
    const { time, qualification, communication } = this.state

    const ratingSelected = time && qualification && communication

    if (isTicketClosed) {
      return (
        <StyledButton
          disabled={!ratingSelected}
          onClick={this.closeTicketHandler}
        >
          {t('tickets:sendFeedback')}
        </StyledButton>
      )
    } else {
      if (ratingSelected) {
        return (
          <StyledButton onClick={this.closeTicketHandler}>
            {t('tickets:sendFeedback')}
          </StyledButton>
        )
      }

      return (
        <StyledButton onClick={this.closeTicketHandler}>
          {t('common:skip')}
        </StyledButton>
      )
    }
  }
}

Feedback.defaultProps = {
  initialRate: 0,
  allowToClose: true,
  loading: false
}

export default withNamespaces()(Feedback)
